import { PageHero } from "../components/ui-kit";
import { Reveal } from "../components/motion";

const content = {
  privacy: {
    label: "Privacy Policy",
    title: <>Your privacy <span className="text-accent">matters.</span></>,
    sections: [
      ["Information We Collect", "We collect information you provide directly — such as your name, email, phone number and coaching application details — as well as usage data through cookies and analytics tools."],
      ["How We Use Your Information", "To respond to coaching applications and enquiries, deliver digital products, send newsletters you opt into, and improve our services. We never sell your data."],
      ["Data Security", "We use industry-standard measures to protect your information. All form submissions are transmitted securely over HTTPS."],
      ["Third-Party Services", "We use trusted services (analytics, email, payment processors) that process data on our behalf under strict confidentiality."],
      ["Your Rights", "You may request access to, correction of, or deletion of your personal data at any time by contacting us."],
      ["Contact", "For any privacy questions, email manavfitcoach@gmail.com."],
    ],
  },
  terms: {
    label: "Terms & Conditions",
    title: <>The <span className="text-accent">fine print.</span></>,
    sections: [
      ["Acceptance of Terms", "By using this website and our services, you agree to these terms. If you disagree, please do not use our services."],
      ["Coaching Services", "Coaching is provided as guidance only. Results vary based on individual effort, consistency and adherence. No specific outcome is guaranteed."],
      ["Health Disclaimer", "Always consult a physician before beginning any exercise or nutrition program. We are not liable for injury or health issues arising from use of our programs."],
      ["Digital Products", "Digital products are licensed for personal use only. Redistribution or resale is prohibited. Downloads are generally non-refundable."],
      ["Payments", "Payments are processed securely via third-party gateways (Razorpay for India, PayPal internationally). Prices are subject to change."],
      ["Intellectual Property", "All content, branding and materials are the property of Manav Fit Coach and may not be reproduced without permission."],
    ],
  },
};

export default function Legal({ kind }) {
  const c = content[kind];
  return (
    <div data-testid={`${kind}-page`}>
      <PageHero label={c.label} title={c.title} subtitle={`Last updated: ${new Date().toLocaleDateString()}`} />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-10">
          {c.sections.map(([h, b], i) => (
            <Reveal key={h} delay={i * 0.05}>
              <h2 className="font-heading font-bold text-2xl mb-3">{h}</h2>
              <p className="text-muted-foreground leading-relaxed">{b}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
